import clsx from 'clsx';
import styles from './Input.module.scss';

import { MouseEvent, useId, useMemo, type ReactNode } from 'react';
import { InputContext, InputContextValue } from './InputContext';
import { InputStatus } from './InputStatus';

interface Props {
  children: ReactNode | ((args: { id: string }) => ReactNode);
  id?: string;
  label: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  status?: InputStatus;
}

export function Input(props: Props) {
  const id = useId();
  const className = clsx(styles['root']);
  const labelClassName = clsx(styles['label']);
  const labelHtmlFor = props.id ?? id;
  const childrenClassName = clsx(styles['children']);
  const children =
    typeof props.children === 'function'
      ? props.children({ id })
      : props.children;

  const contextValue = useMemo<InputContextValue>(() => ({ id }), [id]);

  return (
    <InputContext.Provider value={contextValue}>
      <div className={className} onClick={props.onClick}>
        <label className={labelClassName} htmlFor={labelHtmlFor}>
          {props.label}
        </label>
        <div className={childrenClassName}>{children}</div>
      </div>
    </InputContext.Provider>
  );
}
